/*eslint-disable import/default */
import 'babel-polyfill';
import React from 'react';
import {render} from 'react-dom';
import configureStore from './store/configureStore';
import {Provider} from 'react-redux';
import {Router,browserHistory } from 'react-router';
import routes from './routes';
import {loadUsers,loadUser} from './actions/userActions';
import {loadCollections, loadCollection} from './actions/collectionActions';
import './styles/styles.scss';
import '../node_modules/toastr/build/toastr.min.css';

const store = configureStore();
store.dispatch(loadUsers());
store.dispatch(loadUser());
store.dispatch(loadCollection([]));

render(
	<Provider store={store}>
		<Router history={browserHistory} routes={routes} />
	</Provider>,
	document.getElementById('app')
);


/** WEBPACK FOOTER **
 ** ./src/index.js
 **/